import { accountChangeFieldConnect, accountChangeMetadata } from '../../../actions/AccountActions/AccountActions';
import { InputConnect, InputFile, RadioConnect, SelectAddConnect, SelectConnect, TextareaConnect } from '../../FormsConnect/';
import InputConnectTelephone from '../../FormsConnect/InputConnectTelephone';
import InputEmailConnect from '../../FormsConnect/InputEmailConnect';
import EditFieldConnect from '../EditField/EditFieldConnect';
import CheckboxesConnect from '../../FormsConnect/CheckboxesConnect';

export const firstName = {
  Component: InputConnect,
  props: {
    id: 'firstName',
    label: 'step1.firstName',
    required: true,
    name: 'firstName' as const,
    autoFocus: true,
    autocomplete: 'on',
    tabIndex: 1,
    pathValue: ['account', 'dataFields', 'firstName', 'value'],
    pathErrors: ['account', 'dataFields', 'firstName', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 1,
  },
};

export const lastName = {
  Component: InputConnect,
  props: {
    id: 'lastName',
    label: 'step1.step1SecondColumn.lastName',
    required: true,
    name: 'lastName' as const,
    autocomplete: 'on',
    tabIndex: 2,
    pathValue: ['account', 'dataFields', 'lastName', 'value'],
    pathErrors: ['account', 'dataFields', 'lastName', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 2,
  },
};

export const fullName = {
  Component: InputConnect,
  props: {
    id: 'fullName',
    label: 'account.fullName',
    required: true,
    name: 'fullName' as const,
    autocomplete: 'on',
    tabIndex: 3,
    pathValue: ['account', 'dataFields', 'fullName', 'value'],
    pathErrors: ['account', 'dataFields', 'fullName', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    info: 'account.fullName.message',
    orderMobile: 3,
  },
};

export const publicName = {
  Component: RadioConnect,
  props: {
    id: 'publicName',
    label: 'account.fullName.public',
    required: true,
    name: 'publicName' as const,
    tabIndex: 4,
    pathValue: ['account', 'dataFields', 'publicName', 'value'],
    pathErrors: ['account', 'dataFields', 'publicName', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: 'PUBLIC' },
      { label: 'app.no', value: 'PRIVATE' },
    ],
    orderMobile: 4,
    isStringValue: true,
    info: 'account.publicHint',
  },
};

export const profileEmail = {
  Component: EditFieldConnect,
  props: {
    id: 'email',
    name: 'email' as const,
    label: 'account.email',
    autocomplete: 'email',
    pathValue: ['account', 'dataFields', 'email', 'value'],
    btnLabel: 'change.email.profile',
    url: '/profile/account/change-email',
    tabIndex: 4,
    orderMobile: 4,
    showButton: true,
  },
};

export const profilePassword = {
  Component: EditFieldConnect,
  props: {
    id: 'password',
    name: 'password' as const,
    label: 'step1.password',
    pathValue: ['account', 'dataFields', 'password', 'value'],
    btnLabel: 'step1.change.password',
    url: '/profile/change-password',
    tabIndex: 6,
    typePassword: true,
    orderMobile: 5,
  },
};

export const email = {
  Component: InputEmailConnect,
  props: {
    id: 'email',
    type: 'email',
    label: 'account.emailAddress',
    required: true,
    name: 'email' as const,
    autocomplete: 'email',
    autoFocus: true,
    tabIndex: 4,
    pathValue: ['account', 'dataFields', 'email', 'value'],
    pathErrors: ['account', 'dataFields', 'email', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 4,
  },
};

export const telephone = {
  Component: InputConnectTelephone,
  props: {
    id: 'telephone',
    type: 'text',
    label: 'step1.step1SecondColumn.phoneNumber',
    name: 'telephone' as const,
    required: true,
    autocomplete: 'tel',
    tabIndex: 5,
    pathValue: ['account', 'dataFields', 'telephone', 'value'],
    pathErrors: ['account', 'dataFields', 'telephone', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 6,
  },
};

export const allowSMS = {
  Component: RadioConnect,
  props: {
    id: 'allowSMS',
    label: 'step1.doYouAgree',
    required: true,
    name: 'allowSMS' as const,
    tabIndex: 7,
    pathValue: ['account', 'dataFields', 'allowSMS', 'value'],
    pathErrors: ['account', 'dataFields', 'allowSMS', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.additionalFees',
    orderMobile: 7,
  },
};

export const gender = {
  Component: SelectConnect,
  props: {
    required: true,
    pathValue: ['account', 'dataFields', 'gender', 'value'],
    pathErrors: ['account', 'dataFields', 'gender', 'errors'],
    pathOptions: ['account', 'metadata', 'gender'],
    name: 'gender' as const,
    label: 'account.field.label.gender',
    onChangeFieldAction: accountChangeFieldConnect,
    searchInput: { id: 'gender' },
    tabIndex: 10,
    autocomplete: 'sex',
    placeholder: 'account.field.placeholder.gender',
    info: 'account.gender.message',
    search: false,
    orderMobile: 7,
  },
};

export const referrer = {
  Component: InputConnect,
  props: {
    autocomplete: false,
    id: 'referrer',
    type: 'text',
    label: 'account.referrer',
    required: false,
    name: 'referrer' as const,
    tabIndex: 11,
    pathValue: ['account', 'dataFields', 'referrer', 'value'],
    pathErrors: ['account', 'dataFields', 'referrer', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    info: 'account.referrer.message',
    orderMobile: 8,
  },
};

export const referrerToggle = {
  props: {
    id: 'referrerToggle',
    label: 'account.referrerToggle',
    name: 'referrerToggle' as const,
  },
};

export const countryPhoneMismatch = {
  props: {
    id: 'countryPhoneMismatch',
    name: 'countryPhoneMismatch' as const,
  },
};

export const photo = {
  Component: InputFile,
  props: {
    width: 16,
    id: 'photo',
    label: 'account.photo',
    name: 'photo' as const,
    tabIndex: 0,
    acceptFiles: 'image/jpeg,image/jpg,image/png',
    orderMobile: 0,
    showFileList: false,
    type: 'photo',
    showPreview: true,
  },
};

export const publicPhoto = {
  Component: RadioConnect,
  props: {
    id: 'publicPhoto',
    label: 'account.photo.public',
    required: true,
    name: 'publicPhoto' as const,
    tabIndex: 1,
    pathValue: ['account', 'dataFields', 'publicPhoto', 'value'],
    pathErrors: ['account', 'dataFields', 'publicPhoto', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: 'PUBLIC' },
      { label: 'app.no', value: 'PRIVATE' },
    ],
    orderMobile: 1,
    isStringValue: true,
    info: 'account.publicHint',
  },
};

export const country = {
  Component: SelectConnect,
  props: {
    required: true,
    width: 16,
    modifiers: ['col-2'],
    oneRow: true,
    pathValue: ['account', 'dataFields', 'country', 'value'],
    pathErrors: ['account', 'dataFields', 'country', 'errors'],
    pathOptions: ['account', 'metadata', 'country'],
    name: 'country' as const,
    autocomplete: 'country',
    label: 'account.field.label.country',
    onChangeFieldAction: accountChangeFieldConnect,
    searchInput: { id: 'country' },
    tabIndex: 8,
    placeholder: 'account.field.placeholder.country',
    info: 'account.field.message.country',
  },
};

export const city = {
  Component: InputConnect,
  props: {
    id: 'city',
    modifiers: ['col-2'],
    width: 16,
    label: 'account.field.label.city',
    name: 'city' as const,
    autocomplete: 'address-level2',
    tabIndex: 3,
    pathValue: ['account', 'dataFields', 'city', 'value'],
    pathErrors: ['account', 'dataFields', 'city', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
  },
};

export const university = {
  Component: SelectAddConnect,
  props: {
    required: true,
    pathValue: ['account', 'dataFields', 'university', 'value'],
    pathErrors: ['account', 'dataFields', 'university', 'errors'],
    pathOptions: ['account', 'metadata', 'university'],
    name: 'university' as const,
    label: 'account.field.label.university',
    pathAddOptions: ['account', 'metadata', 'university'],
    onChangeFieldAction: accountChangeFieldConnect,
    handleAddOptions: accountChangeMetadata,
    searchInput: { id: 'university' },
    allowAdditions: true,
    tabIndex: 9,
    placeholder: 'account.field.placeholder.university',
    info: 'account.field.info.university',
  },
};

export const degree = {
  Component: SelectConnect,
  props: {
    pathValue: ['account', 'dataFields', 'degree', 'value'],
    pathErrors: ['account', 'dataFields', 'degree', 'errors'],
    pathOptions: ['account', 'metadata', 'degree'],
    name: 'degree' as const,
    label: 'account.field.label.degree',
    onChangeFieldAction: accountChangeFieldConnect,
    searchInput: { id: 'degree' },
    tabIndex: 10,
    placeholder: 'account.field.placeholder.degree',
  },
};

export const graduationYear = {
  Component: SelectConnect,
  props: {
    pathValue: ['account', 'dataFields', 'graduationYear', 'value'],
    pathErrors: ['account', 'dataFields', 'graduationYear', 'errors'],
    pathOptions: ['account', 'metadata', 'graduationYear'],
    shouldCreatedOptions: true,
    firstOptionKey: 'minValue',
    lastOptionKey: 'maxValue',
    name: 'graduationYear' as const,
    label: 'account.field.label.graduationYear',
    onChangeFieldAction: accountChangeFieldConnect,
    searchInput: { id: 'graduationYear' },
    tabIndex: 11,
    placeholder: 'account.field.placeholder.graduationYear',
  },
};

export const major = {
  Component: InputConnect,
  props: {
    id: 'major',
    label: 'account.field.label.major',
    name: 'major' as const,
    tabIndex: 13,
    pathValue: ['account', 'dataFields', 'major', 'value'],
    pathErrors: ['account', 'dataFields', 'major', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
  },
};

export const gpa = {
  Component: InputConnect,
  props: {
    id: 'gpa',
    width: 16,
    label: 'account.field.label.gpa',
    name: 'gpa',
    tabIndex: 6,
    type: 'number',
    min: 1,
    step: '0.1',
    pathValue: ['account', 'dataFields', 'gpa', 'value'],
    pathErrors: ['account', 'dataFields', 'gpa', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
  },
};

export const maxGPA = {
  Component: InputConnect,
  props: {
    id: 'maxGPA',
    width: 16,
    label: 'account.field.label.maxGPA',
    name: 'maxGPA',
    tabIndex: 7,
    type: 'number',
    min: 1,
    step: '0.1',
    pathValue: ['account', 'dataFields', 'maxGPA', 'value'],
    pathErrors: ['account', 'dataFields', 'maxGPA', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
  },
};

export const stem = {
  Component: RadioConnect,
  props: {
    id: 'stem',
    label: 'account.field.label.stem',
    name: 'stem' as const,
    tabIndex: 7,
    pathValue: ['account', 'dataFields', 'stem', 'value'],
    pathErrors: ['account', 'dataFields', 'stem', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.scienceTechnology',
  },
};

export const presentlyEmployed = {
  Component: RadioConnect,
  props: {
    id: 'presently_employed',
    label: 'account.field.label.presently_employed',
    required: true,
    name: 'presently_employed' as const,
    tabIndex: 12,
    pathValue: ['account', 'dataFields', 'presently_employed', 'value'],
    pathErrors: ['account', 'dataFields', 'presently_employed', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 1,
  },
};

export const employer = {
  Component: InputConnect,
  props: {
    required: true,
    id: 'employer',
    label: 'account.field.label.employer',
    name: 'employer' as const,
    tabIndex: 2,
    autocomplete: 'organization',
    pathValue: ['account', 'dataFields', 'employer', 'value'],
    pathErrors: ['account', 'dataFields', 'employer', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 2,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const title = {
  Component: InputConnect,
  props: {
    required: true,
    id: 'title',
    label: 'account.field.label.title',
    name: 'title' as const,
    tabIndex: 4,
    autocomplete: 'organization-title',
    pathValue: ['account', 'dataFields', 'title', 'value'],
    pathErrors: ['account', 'dataFields', 'title', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 4,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const business = {
  Component: InputConnect,
  props: {
    required: true,
    id: 'business',
    label: 'account.field.label.business',
    name: 'business' as const,
    tabIndex: 3,
    pathValue: ['account', 'dataFields', 'business', 'value'],
    pathErrors: ['account', 'dataFields', 'business', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    placeholder: 'account.brokerage.employed',
    orderMobile: 3,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const description = {
  Component: TextareaConnect,
  props: {
    required: true,
    id: 'description',
    label: 'account.field.label.description',
    name: 'description' as const,
    tabIndex: 5,
    pathValue: ['account', 'dataFields', 'description', 'value'],
    pathErrors: ['account', 'dataFields', 'description', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 5,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const participationPermitted = {
  Component: RadioConnect,
  props: {
    id: 'participationPermitted',
    label: 'account.field.label.participationPermitted',
    required: true,
    name: 'participationPermitted' as const,
    tabIndex: 6,
    pathValue: ['account', 'dataFields', 'participationPermitted', 'value'],
    pathErrors: ['account', 'dataFields', 'participationPermitted', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 5,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const nonPublicInformation = {
  Component: RadioConnect,
  props: {
    id: 'nonPublicInformation',
    label: 'account.field.label.nonPublicInformation',
    required: true,
    name: 'nonPublicInformation' as const,
    tabIndex: 7,
    pathValue: ['account', 'dataFields', 'nonPublicInformation', 'value'],
    pathErrors: ['account', 'dataFields', 'nonPublicInformation', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.field.info.nonPublicInformation',
    orderMobile: 6,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const finance = {
  Component: RadioConnect,
  props: {
    id: 'finance',
    label: 'account.field.label.finance',
    required: true,
    name: 'finance' as const,
    tabIndex: 8,
    pathValue: ['account', 'dataFields', 'finance', 'value'],
    pathErrors: ['account', 'dataFields', 'finance', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.field.info.finance',
    orderMobile: 7,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const investmentAdvisory = {
  Component: RadioConnect,
  props: {
    id: 'investmentAdvisory',
    label: 'account.field.label.investmentAdvisory',
    required: true,
    name: 'investmentAdvisory' as const,
    tabIndex: 9,
    pathValue: ['account', 'dataFields', 'investmentAdvisory', 'value'],
    pathErrors: ['account', 'dataFields', 'investmentAdvisory', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 9,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const brokerage = {
  Component: RadioConnect,
  props: {
    id: 'brokerage',
    label: 'account.field.label.brokerage',
    required: true,
    name: 'brokerage' as const,
    tabIndex: 10,
    pathValue: ['account', 'dataFields', 'brokerage', 'value'],
    pathErrors: ['account', 'dataFields', 'brokerage', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 10,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const fundamentalResearch = {
  Component: RadioConnect,
  props: {
    id: 'fundamentalResearch',
    label: 'account.field.label.fundamentalResearch',
    required: true,
    name: 'fundamentalResearch' as const,
    tabIndex: 11,
    pathValue: ['account', 'dataFields', 'fundamentalResearch', 'value'],
    pathErrors: ['account', 'dataFields', 'fundamentalResearch', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 11,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const proprietaryTrading = {
  Component: RadioConnect,
  props: {
    id: 'proprietaryTrading',
    label: 'account.field.label.proprietaryTrading',
    required: true,
    name: 'proprietaryTrading' as const,
    tabIndex: 12,
    pathValue: ['account', 'dataFields', 'proprietaryTrading', 'value'],
    pathErrors: ['account', 'dataFields', 'proprietaryTrading', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    orderMobile: 12,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const serviceEngagement = {
  Component: RadioConnect,
  props: {
    id: 'serviceEngagement',
    label: 'account.field.label.serviceEngagement',
    required: true,
    name: 'serviceEngagement' as const,
    tabIndex: 13,
    pathValue: ['account', 'dataFields', 'serviceEngagement', 'value'],
    pathErrors: ['account', 'dataFields', 'serviceEngagement', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.field.info.serviceEngagement',
    orderMobile: 13,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const exposureStatus = {
  Component: RadioConnect,
  props: {
    id: 'exposureStatus',
    label: 'account.field.label.exposureStatus',
    required: true,
    name: 'exposureStatus' as const,
    tabIndex: 14,
    pathValue: ['account', 'dataFields', 'exposureStatus', 'value'],
    pathErrors: ['account', 'dataFields', 'exposureStatus', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'app.yes', value: true },
      { label: 'app.no', value: false },
    ],
    info: 'account.field.info.exposureStatus',
    orderMobile: 15,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const employerServices = {
  Component: TextareaConnect,
  props: {
    id: 'employerServices',
    name: 'employerServices' as const,
    tabIndex: 15,
    pathValue: ['account', 'dataFields', 'employerServices', 'value'],
    pathErrors: ['account', 'dataFields', 'employerServices', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 14,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const exposureDetails = {
  Component: TextareaConnect,
  props: {
    id: 'exposureDetails',
    name: 'exposureDetails' as const,
    tabIndex: 16,
    pathValue: ['account', 'dataFields', 'exposureDetails', 'value'],
    pathErrors: ['account', 'dataFields', 'exposureDetails', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    orderMobile: 16,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};
export const agreeTermsConditions = {
  props: {
    id: 'agree',
    name: 'agree' as const,
  },
};
export const privacyPolicy = {
  props: {
    id: 'agreePrivacyPolicy',
    name: 'agreePrivacyPolicy' as const,
  },
};
export const accountCreatePassword = {
  props: {
    id: 'password',
    name: 'password' as const,
    autocomplete: 'off',
  },
};

export const agreeCompetition = {
  props: {
    id: 'agreeCompetition',
    name: 'agreeCompetition' as const,
  },
};

export const captcha = {
  props: {
    id: 'captcha',
    name: 'captcha' as const,
  },
};

export const englishProficiency = {
  Component: RadioConnect,
  props: {
    id: 'englishProficiency',
    label: 'account.field.label.englishProficiency',
    required: false,
    name: 'englishProficiency' as const,
    tabIndex: 12,
    isStringValue: true,
    pathValue: ['account', 'dataFields', 'englishProficiency', 'value'],
    pathErrors: ['account', 'dataFields', 'englishProficiency', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'account.proficiencyLevel.high', value: 'HIGH' },
      { label: 'account.proficiencyLevel.medium', value: 'MEDIUM' },
      { label: 'account.proficiencyLevel.low', value: 'LOW' },
    ],
    orderMobile: 12,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const codingProficiency = {
  Component: RadioConnect,
  props: {
    id: 'codingProficiency',
    label: 'account.field.label.codingProficiency',
    required: false,
    name: 'codingProficiency' as const,
    tabIndex: 12,
    isStringValue: true,
    pathValue: ['account', 'dataFields', 'codingProficiency', 'value'],
    pathErrors: ['account', 'dataFields', 'codingProficiency', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'account.proficiencyLevel.high', value: 'HIGH' },
      { label: 'account.proficiencyLevel.medium', value: 'MEDIUM' },
      { label: 'account.proficiencyLevel.low', value: 'LOW' },
    ],
    orderMobile: 12,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const roleInterest = {
  Component: CheckboxesConnect,
  props: {
    id: 'roleInterest',
    label: 'account.field.label.roles',
    required: false,
    name: 'roleInterest' as const,
    tabIndex: 12,
    isStringValue: true,
    pathValue: ['account', 'dataFields', 'roleInterest', 'value'],
    pathErrors: ['account', 'dataFields', 'roleInterest', 'errors'],
    onChangeFieldAction: accountChangeFieldConnect,
    options: [
      { label: 'account.roles.research', value: 'RESEARCH' },
      { label: 'account.roles.business', value: 'BUSINESS' },
      { label: 'account.roles.technology', value: 'TECHNOLOGY' },
    ],
    orderMobile: 12,
    tablet: 16,
    width: 16,
    mobile: 16,
    computer: 8,
  },
};

export const resume = {
  Component: InputFile,
  props: {
    width: 16,
    id: 'resume',
    label: 'account.field.label.resume',
    name: 'resume',
    type: 'resume',

    tabIndex: 8,
    // tslint:disable-next-line: max-line-length
    acceptFiles: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    orderMobile: 9,
    hintId: 'account.field.info.resume',
  },
};
